export default __webpack_public_path__ + "static/media/comment.b5dc0dc5.svg";